import React, { memo } from 'react';
import { FeaturesItemCard } from './FeaturesItemCard';
/**
 * Default Item Card, reuse for:
 * - 'Features Carousel Component'
 */
function CollapsingFeaturesItemCardComponent(props) {
    return React.createElement(FeaturesItemCard, { ...props });
}
export const CollapsingFeaturesItemCard = memo(CollapsingFeaturesItemCardComponent);
CollapsingFeaturesItemCard.displayName = 'CollapsingFeaturesItemCard_Molecule';
